import { useTranslation } from 'react-i18next';
import styles from './ExternalClientAccessInfo.module.scss';
import { getExternalAccessStorage } from 'utils/externalAccess';
import { getCountry } from 'utils/country';
import countries from 'constants/countries';

export default function ExternalClientAccessInfo() {
  const { t } = useTranslation();
  const { activityLogInfo } = getExternalAccessStorage();

  const getTimeLabel = (accessedAt) => {
    const country = getCountry();
    const locale = country === countries.US ? 'en-US' : 'en-GB';
    const now = new Date();
    const accessedDateTime = new Date(accessedAt);
    const delta = now - accessedDateTime;
    const deltaDays = delta / (1000 * 60 * 60 * 24);

    let result = '';
    if (deltaDays >= 2) {
      result = `${t('externalAccess.time.on')} ${accessedDateTime.toLocaleDateString(locale)}`;
    } else if (deltaDays >= 1 && deltaDays < 2) {
      result = t('externalAccess.time.yesterday');
    } else if (deltaDays < 1) {
      const deltaHours = Math.floor(delta / (1000 * 60 * 60));
      if (deltaHours >= 1) {
        result = `${deltaHours} ${t('externalAccess.time.hours', { count: deltaHours })}`;
      } else {
        const deltaMinutes = Math.floor(delta / (1000 * 60));
        result = `${deltaMinutes} ${t('externalAccess.time.minutes', { count: deltaMinutes })}`;
      }
      result = t('externalAccess.time.ago', { value: result });
    }
    return result;
  };

  return (
    activityLogInfo && (
      <div className={styles.container}>
        <div>
          <span>{t('externalAccess.from')}</span>
          <span>{activityLogInfo.clientEmail}</span>
          <span>{`${t('externalAccess.time.lastAccessed')} ${getTimeLabel(
            activityLogInfo.accessedAt,
          )}`}</span>
        </div>
      </div>
    )
  );
}
